// extracted by mini-css-extract-plugin
export default {"FormSection":"FormSection_FormSection__yPdgb","active":"FormSection_active__kQ4uw"};